import {ComponentFactoryResolver, Injector, NgModule} from '@angular/core';
import {NZ_DATE_LOCALE, NZ_I18N} from 'ng-zorro-antd/i18n';

import {DecimalPipe, LocationStrategy, PathLocationStrategy, registerLocaleData} from '@angular/common';
import vi from '@angular/common/locales/vi';
import {vi as vi_DATE} from 'date-fns/locale';

import {AppRoutingModule} from './app-routing.module';
import {TemplateModule} from '@shared/template/template.module';

import {AppComponent} from './app.component';
import {CommonLayoutComponent} from './layouts/common-layout/common-layout.component';
import {FullLayoutComponent} from './layouts/full-layout/full-layout.component';

import {ThemeConstantService} from '@shared/services/theme-constant.service';
import {NZ_CONFIG} from 'ng-zorro-antd/core/config';
import {GlobalTemplatesComponent} from '@app/ng-zorro/nz-config/global-templates.component';
import {nzConfigFactory} from '@app/ng-zorro/nz-config';
import {CoreModule} from '@core/core.module';
import {NotificationService} from '@shared/services/notification.service';
import {TablerIconModule} from '@shared/icons/tabler-icon.module';
import {NzIconModule} from 'ng-zorro-antd/icon';
import {CurrentUserService} from '@shared/services/current-user.service';
import {vi_VN_ext} from '@app/ng-zorro/nz-i18n/vi_VN.extra';
import {SharedModule} from '@shared/shared.module';
import {BaseService} from '@core/service/base.service';
import {HTTP_INTERCEPTORS, HttpClientXsrfModule} from '@angular/common/http';
import {CustomHttpInterceptor} from '@core/interceptor/http-intercepter';
import {XsrfInterceptor} from '@core/interceptor/xsrf-interceptor';
import {TitleStrategy} from '@angular/router';
import {TemplatePageTitleStrategy} from '@core/strategy/template-page-title.strategy';
import {UploadFileService} from "@shared/services/upload-file.service";
import {FormatCurrencyPipe} from '@shared/pipes/format-currency.pipe';

registerLocaleData(vi);
const ANT_MODULES = [NzIconModule, TablerIconModule];

@NgModule({
    bootstrap: [AppComponent],
    declarations: [
        AppComponent,
        CommonLayoutComponent,
        FullLayoutComponent,
        GlobalTemplatesComponent,
    ],
    imports: [
        AppRoutingModule,
        CoreModule,
        SharedModule,
        TemplateModule,

        HttpClientXsrfModule.withOptions({
            cookieName: 'CSRF-TOKEN',
            headerName: 'CSRF-TOKEN'
        }),
        ...ANT_MODULES
    ],
    providers: [
        {provide: NZ_DATE_LOCALE, useValue: vi_DATE},
        {
            provide: NZ_I18N,
            useValue: vi_VN_ext,
        },
        {
            provide: TitleStrategy,
            useClass: TemplatePageTitleStrategy
        },
        {
            provide: LocationStrategy,
            useClass: PathLocationStrategy
        },
        { // The FactoryProvider
            provide: NZ_CONFIG,
            useFactory: nzConfigFactory,
            deps: [Injector, ComponentFactoryResolver]
        },
        ThemeConstantService,
        NotificationService,
        CurrentUserService,
        UploadFileService,
        BaseService,
        DecimalPipe,
        FormatCurrencyPipe,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: CustomHttpInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: XsrfInterceptor,
            multi: true
        }
    ]
})
export class AppModule {
}
